module.exports = __webpack_public_path__ + "img/learner-quiz-Moose-Q3.c953cdd7.png";